import React, { useEffect, useState, createContext, useContext, ReactNode } from 'react';
import { translations } from '../i18n/translations';
type Language = 'en' | 'es';
interface LanguageContextType {
  lang: Language | null;
  setLang: (lang: Language) => void;
  t: (key: string) => string;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [lang, setLangState] = useState<Language | null>(null);
  useEffect(() => {
    const stored = window.localStorage.getItem('rs_lang') as Language;
    if (stored === 'es' || stored === 'en') {
      setLangState(stored);
    }
  }, []);
  const setLang = (newLang: Language) => {
    window.localStorage.setItem('rs_lang', newLang);
    setLangState(newLang);
  };
  const t = (path: string): string => {
    if (!lang) return '';
    const keys = path.split('.');
    let current: any = translations[lang];
    for (const key of keys) {
      if (current && current[key] !== undefined) {
        current = current[key];
      } else {
        // Fallback to English
        let fallback: any = translations['en'];
        for (const k of keys) {
          if (fallback && fallback[k] !== undefined) {
            fallback = fallback[k];
          } else {
            return path; // Return key path if not found in fallback either
          }
        }
        return fallback;
      }
    }
    return current;
  };
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-597">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}